<template>
    <a :href="link" title="LinkedIn" aria-labelledby="linked-in-icon-link">
        <svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g>
                <path
                    d="M5.98928 21.4275H1.38332V8.26555H5.98928V21.4275ZM15.5518 12.5553C15.0139 12.5553 14.4981 12.7683 14.1177 13.1475C13.7374 13.5267 13.5237 14.041 13.5237 14.5773V21.4275H8.68081V8.26555H13.5237V9.76789C14.6589 8.80984 16.0929 8.27536 17.5799 8.25609C20.5843 8.25609 22.6693 10.4765 22.6693 14.6906V21.4275H17.5799V14.5773C17.5813 14.311 17.5297 14.047 17.4283 13.8006C17.327 13.5542 17.1778 13.3301 16.9893 13.1414C16.8009 12.9526 16.5769 12.8028 16.3302 12.7006C16.0835 12.5984 15.819 12.5458 15.5518 12.5458V12.5553ZM6.07457 3.71129C6.07457 4.17848 5.93561 4.63519 5.67527 5.02364C5.41492 5.41209 5.04488 5.71487 4.61195 5.89365C4.17902 6.07244 3.70263 6.11921 3.24303 6.02807C2.78342 5.93692 2.36124 5.71195 2.0299 5.3816C1.69854 5.05124 1.47288 4.63035 1.38147 4.17212C1.29004 3.71391 1.33696 3.23896 1.5163 2.80732C1.69562 2.37569 1.9993 2.00677 2.38894 1.74721C2.77856 1.48765 3.23664 1.34912 3.70525 1.34912C4.33035 1.35411 4.92814 1.60517 5.36838 2.04763C5.80862 2.49008 6.05564 3.08807 6.05562 3.71129H6.07457Z"
                    stroke="var(--joy-color-secondary-50)"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    fill="transparent"
                />
            </g>
        </svg>

        <span id="linked-in-icon-link" hidden>LinkedIn</span>
    </a>
</template>

<script setup lang="ts">
    defineProps<{link: string}>();
</script>
